import { BoardDetailState, BoardDetailAction } from '@/types/state';

export const initialBoardDetailState: BoardDetailState = {
  board: null,
  personas: [],
  projects: [],
  availableBoards: [],
  loading: true,
  
  // Dialog states
  isAddingPersona: false,
  isAddingProject: false,
  isEditingPersona: false,
  showDeleteDialog: false,
  isRegenerateDialogOpen: false,
  
  // Editing states
  isEditingName: false,
  editedName: '',
  isHoveringName: false,
  isEditingDescription: false,
  editedDescription: '',
  isHoveringDescription: false,
  isEditingColor: false,
  editedColor: '',
  isHoveringColor: false,
  
  // Form data
  newPersona: {
    role_name: '',
    mission: '',
    principles: '',
    competencies: '',
    key_relationships: '',
    typical_questions: '',
  },
  editingPersona: null,
  newProjectName: '',
  regeneratingPersona: null,
  regeneratePrompt: '',
  generatedPersonaData: null,
  
  // Delete board handling
  projectsToHandle: [],
  selectedDestinationBoard: null,
};

export function boardDetailReducer(state: BoardDetailState, action: BoardDetailAction): BoardDetailState {
  switch (action.type) {
    case 'SET_BOARD':
      return { ...state, board: action.payload };
      
    case 'UPDATE_BOARD_NAME':
      return {
        ...state,
        board: state.board ? { ...state.board, name: action.payload } : null,
      };
      
    case 'UPDATE_BOARD_DESCRIPTION':
      return {
        ...state,
        board: state.board ? { ...state.board, description: action.payload } : null,
      };
      
    case 'UPDATE_BOARD_COLOR':
      return {
        ...state,
        board: state.board ? { ...state.board, color: action.payload } : null,
      };
      
    case 'SET_PERSONAS':
      return { ...state, personas: action.payload };
      
    case 'SET_PROJECTS':
      return { ...state, projects: action.payload };
      
    case 'SET_AVAILABLE_BOARDS':
      return { ...state, availableBoards: action.payload };
      
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
      
    case 'SET_IS_ADDING_PERSONA':
      return { ...state, isAddingPersona: action.payload };
      
    case 'SET_IS_ADDING_PROJECT':
      return { ...state, isAddingProject: action.payload };
      
    case 'SET_IS_EDITING_PERSONA':
      return { ...state, isEditingPersona: action.payload };
      
    case 'SET_SHOW_DELETE_DIALOG':
      return { ...state, showDeleteDialog: action.payload };
      
    case 'SET_IS_REGENERATE_DIALOG_OPEN':
      return { ...state, isRegenerateDialogOpen: action.payload };
      
    case 'SET_IS_EDITING_NAME':
      return { ...state, isEditingName: action.payload };
      
    case 'SET_EDITED_NAME':
      return { ...state, editedName: action.payload };
      
    case 'SET_IS_HOVERING_NAME':
      return { ...state, isHoveringName: action.payload };
      
    case 'SET_IS_EDITING_DESCRIPTION':
      return { ...state, isEditingDescription: action.payload };
      
    case 'SET_EDITED_DESCRIPTION':
      return { ...state, editedDescription: action.payload };
      
    case 'SET_IS_HOVERING_DESCRIPTION':
      return { ...state, isHoveringDescription: action.payload };
      
    case 'SET_IS_EDITING_COLOR':
      return { ...state, isEditingColor: action.payload };
      
    case 'SET_EDITED_COLOR':
      return { ...state, editedColor: action.payload };
      
    case 'SET_IS_HOVERING_COLOR':
      return { ...state, isHoveringColor: action.payload };
      
    case 'SET_NEW_PERSONA':
      return { ...state, newPersona: action.payload };
      
    case 'UPDATE_NEW_PERSONA_FIELD':
      return {
        ...state,
        newPersona: {
          ...state.newPersona,
          [action.payload.field]: action.payload.value,
        },
      };
      
    case 'RESET_NEW_PERSONA':
      return {
        ...state,
        newPersona: {
          role_name: '',
          mission: '',
          principles: '',
          competencies: '',
          key_relationships: '',
          typical_questions: '',
        },
      };
      
    case 'SET_EDITING_PERSONA':
      return { ...state, editingPersona: action.payload };
      
    case 'UPDATE_EDITING_PERSONA_FIELD':
      return {
        ...state,
        editingPersona: state.editingPersona
          ? { ...state.editingPersona, [action.payload.field]: action.payload.value }
          : null,
      };
      
    case 'SET_NEW_PROJECT_NAME':
      return { ...state, newProjectName: action.payload };
      
    case 'SET_REGENERATING_PERSONA':
      return { ...state, regeneratingPersona: action.payload };
      
    case 'SET_REGENERATE_PROMPT':
      return { ...state, regeneratePrompt: action.payload };
      
    case 'SET_GENERATED_PERSONA_DATA':
      return { ...state, generatedPersonaData: action.payload };
      
    case 'SET_PROJECTS_TO_HANDLE':
      return { ...state, projectsToHandle: action.payload };
      
    case 'SET_SELECTED_DESTINATION_BOARD':
      return { ...state, selectedDestinationBoard: action.payload };
      
    default:
      return state;
  }
}
